import { gql, TypedDocumentNode } from '@apollo/client'

export interface IAgencyActivity {
  agencyActivityId: number
  activityType: string
  request: Record<string, any>
  response: Record<string, any>
  agencyId: string
  retry_details: Record<string, any>[] | null
  status: string
  createdAt: string
}

type GetAgencyActivitiesByAgencyGroupQuery = {
  getAgencyActivitiesByAgencyGroup: IAgencyActivity[]
}

type GetAgencyActivitiesByAgencyVariable = {
  agencyGroupId: number
  activityType: string
  take?: number
  skip?: number
  status: string | null
}

export const GET_AGENCY_ACTIVITY_BY_AGENCY_GROUP: TypedDocumentNode<
  GetAgencyActivitiesByAgencyGroupQuery,
  GetAgencyActivitiesByAgencyVariable
> = gql`
  query GetAgencyActivitiesByAgencyGroup(
    $agencyGroupId: Int!
    $status: String
    $sortCreatedAt: String
    $activityType: String!
    $take: Int
    $skip: Int
  ) {
    getAgencyActivitiesByAgencyGroup(
      agencyGroupId: $agencyGroupId
      status: $status
      sortCreatedAt: $sortCreatedAt
      activityType: $activityType
      take: $take
      skip: $skip
    ) {
      agencyActivityId
      activityType
      request
      response
      agencyId
      retry_details
      status
      createdAt
    }
  }
`

type GetStatusByAgencyGroupIdQuery = {
  getAllStatusByAgencyGroupId: string[]
}

type GetStatusByAgencyGroupIdVariables = {
  agencyGroupId: number
  activityType: string
}
export const GET_STATUS_BY_AGENCY_GROUP_ID: TypedDocumentNode<
  GetStatusByAgencyGroupIdQuery,
  GetStatusByAgencyGroupIdVariables
> = gql`
  query GetAllStatusByAgencyGroupId($agencyGroupId: Int!) {
    getAllStatusByAgencyGroupId(agencyGroupId: $agencyGroupId)
  }
`

type ManualRetryForwardWebHookQuery = {
  manualRetryByAgencyActivityId: boolean
}

type ManualRetryForwardWebHookVariables = {
  agencyActivityId: number
}

export const MANUAL_RETRY_FORWARD_WEBHOOK_BY_AGENCY_ACTIVITY_ID: TypedDocumentNode<
  ManualRetryForwardWebHookQuery,
  ManualRetryForwardWebHookVariables
> = gql`
  query ManualRetryByAgencyActivityId($agencyActivityId: Float!) {
    manualRetryByAgencyActivityId(agencyActivityId: $agencyActivityId)
  }
`
